import React from 'react'
import { BeWizrLearningTrack } from '~/models'
import { memo } from '~/ui/component'
import BeWizrLearningTrackTile from '../../bewizr-learning-tracks/BeWizrLearningTrackTile'
import { register } from './registry'
import { useTranslation } from 'react-i18next'

export interface Props {
  item: BeWizrLearningTrack
}

const BeWizrLearningTrackLibraryItem = memo('BeWizrLearningTrackLibraryItem', (props: Props) => {

  const {item} = props

  const [t] = useTranslation('bewizr-library')

  //------
  // Rendering

  function render() {
    return (
      <BeWizrLearningTrackTile
        label={t('item-types.learning_track')}
        title={item.title}
        id={item.id}
        startDate={item.startDate}
        image={item.links.image}
        itemCount={item.itemCount}
        isEnrolled={item.isEnrolled}
        isOnWaitingList={item.isOnWaitingList}
        placesLeft={item.placesLeft}
        mayEnroll={item.mayEnroll}
        description={item.shortDescription}
        horizontal
      />
    )
  }

  return render()

})

register('learning_track', BeWizrLearningTrackLibraryItem)